import { getLocale, LANGUAGES } from "@/models/utils";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ar from "./ar.json";
import bg from "./bg.json";
import bn from "./bn.json";
import cs from "./cs.json";
import da from "./da.json";
import de from "./de.json";
import el from "./el.json";
import en from "./en.json";
import es from "./es.json";
import et from "./et.json";
import fi from "./fi.json";
import fr from "./fr.json";
import he from "./he.json";
import hi from "./hi.json";
import hr from "./hr.json";
import hu from "./hu.json";
import id from "./id.json";
import it from "./it.json";
import ja from "./ja.json";
import ko from "./ko.json";
import lt from "./lt.json";
import nl from "./nl.json";
import no from "./no.json";
import pl from "./pl.json";
import pt from "./pt.json";
import ro from "./ro.json";
import ru from "./ru.json";
import sl from "./sl.json";
import sr from "./sr.json";
import sv from "./sv.json";
import sw from "./sw.json";
import th from "./th.json";
import tr from "./tr.json";
import uk from "./uk.json";
import vi from "./vi.json";
import zh from "./zh.json";

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt },
  ja: { translation: ja },
  ko: { translation: ko },
  nl: { translation: nl },
  pl: { translation: pl },
  sv: { translation: sv },
  no: { translation: no },
  da: { translation: da },
  fi: { translation: fi },
  cs: { translation: cs },
  ar: { translation: ar },
  bg: { translation: bg },
  bn: { translation: bn },
  el: { translation: el },
  et: { translation: et },
  he: { translation: he },
  hi: { translation: hi },
  hr: { translation: hr },
  hu: { translation: hu },
  id: { translation: id },
  lt: { translation: lt },
  ro: { translation: ro },
  ru: { translation: ru },
  sl: { translation: sl },
  sr: { translation: sr },
  sw: { translation: sw },
  th: { translation: th },
  tr: { translation: tr },
  uk: { translation: uk },
  vi: { translation: vi },
  zh: { translation: zh },
};

const appLanguages = Object.keys(resources).map((item) =>
  LANGUAGES.find((lang) => lang.value === item)
);

if (!i18n.isInitialized && typeof window === "object") {
  i18n.use(initReactI18next).init({
    resources,
    lng: getLocale(),
    fallbackLng: "en",
    compatibilityJSON: "v4",
    interpolation: {
      escapeValue: false,
    },
  });
}

export { i18n, appLanguages };
